// Constants
import { gaussianBlurSigma } from "../constants";

const calcPercentage = (total, partial) => {
  let percentage = 0;

  if (total && partial) {
    percentage = 100 * (partial / total);
    return Math.round(percentage);
  }

  return Math.round(percentage);
};

const cleanSelections = (data) => {
  try {
    // eslint-disable-next-line array-callback-return
    data.map((item) => {
      item.checked = false;
    });
    return data;
  } catch (error) {
    return data;
  }
};

const getDefaultPalleteRgb = () => {
  return [[252,243,243],[250,237,237],[249,232,232],[248,226,226],[247,221,221],[246,215,215],[245,210,210],[243,205,205],[242,199,199],[241,194,194],[240,188,188],[239,183,183],[238,178,178],[236,172,172],[235,167,167],[234,161,161],[233,156,156],[232,150,150],[231,145,145],[229,140,140],[228,134,134],[227,129,129],[226,123,123],[225,118,118],[224,113,113],[223,107,107],[221,102,102],[220,96,96],[219,91,91],[218,85,85],[217,80,80],[216,75,75],[214,69,69],[213,64,64],[212,58,58],[211,53,53],[210,48,48],[209,42,42],[207,37,37],[206,31,31],[205,26,26],[204,21,21],[203,15,15],[202,10,10],[201,4,4],[200,0,0],[201,7,0],[203,14,0],[204,21,0],[206,28,0],[207,35,0],[209,42,0],[210,49,0],[212,56,0],[213,63,0],[215,70,0],[216,77,0],[218,84,0],[219,91,0],[221,98,0],[222,105,0],[224,112,0],[225,119,0],[227,126,0],[228,133,0],[230,140,0],[231,147,0],[233,154,0],[234,161,0],[236,168,0],[237,175,0],[239,182,0],[240,189,0],[242,196,0],[243,203,0],[245,210,0],[246,217,0],[248,224,0],[249,231,0],[251,238,0],[252,245,0],[254,252,0],[250,252,0],[243,248,0],[236,244,0],[229,240,0],[222,236,0],[215,232,0],[208,228,0],[201,224,0],[194,220,0],[187,216,0],[180,212,0],[173,208,0],[166,204,0],[159,200,0],[152,196,0],[145,192,0],[138,188,0],[131,184,0],[124,180,0],[117,176,0],[110,172,0],[103,168,0],[96,164,0],[89,160,0],[82,156,0],[75,152,0],[68,149,0],[61,145,0],[54,141,0],[47,137,0],[40,133,0],[33,129,0],[26,125,0],[19,121,0],[12,117,0],[5,113,0],[0,110,1],[0,115,8],[0,119,16],[0,123,23],[0,127,31],[0,131,38],[0,136,45],[0,140,53],[0,144,60],[0,148,68],[0,152,75],[0,157,82],[0,161,90],[0,165,97],[0,169,105],[0,173,112],[0,178,119],[0,182,127],[0,186,134],[0,190,142],[0,195,149],[0,199,156],[0,203,164],[0,207,171],[0,211,179],[0,216,186],[0,220,194],[0,224,201],[0,228,208],[0,232,216],[0,237,223],[0,241,231],[0,245,238],[0,249,245],[0,254,253],[0,249,253],[0,241,251],[0,234,248],[0,226,246],[0,219,244],[0,211,242],[0,204,240],[0,197,237],[0,189,235],[0,182,233],[0,174,231],[0,167,229],[0,159,226],[0,152,224],[0,144,222],[0,137,220],[0,129,218],[0,122,216],[0,114,213],[0,107,211],[0,100,209],[0,92,207],[0,85,205],[0,77,202],[0,70,200],[0,62,198],[0,55,196],[0,47,194],[0,40,191],[0,32,189],[0,25,187],[0,17,185],[0,10,183],[0,3,180],[4,0,181],[11,0,183],[19,0,185],[26,0,187],[34,0,190],[41,0,192],[48,0,194],[56,0,196],[63,0,198],[71,0,200],[78,0,203],[85,0,205],[93,0,207],[100,0,209],[108,0,211],[115,0,213],[122,0,216],[130,0,218],[137,0,220],[145,0,222],[152,0,224],[159,0,227],[167,0,229],[174,0,231],[182,0,233],[189,0,235],[196,0,237],[204,0,240],[211,0,242],[219,0,244],[226,0,246],[234,0,248],[241,0,251],[248,0,253],[253,0,253],[246,0,246],[238,0,238],[231,0,231],[223,0,223],[216,0,216],[208,0,208],[201,0,201],[194,0,194],[186,0,186],[179,0,179],[171,0,171],[164,0,164],[156,0,156],[149,0,149],[141,0,141],[134,0,134],[126,0,126],[119,0,119],[111,0,111],[104,0,104],[97,0,97],[89,0,89],[82,0,82],[74,0,74],[67,0,67],[59,0,59],[52,0,52],[44,0,44],[37,0,37],[29,0,29],[22,0,22],[14,0,14],[7,0,7],[0,0,0]];
};

const makeGaussianKernel = (sigma) => {
  const GAUSSKERN = 3.0;
  const dim = parseInt(Math.max(3.0, GAUSSKERN * sigma));
  const sqrtSigmaPi2 = Math.sqrt(Math.PI*2.0)*sigma;
  const s2 = 2.0 * sigma * sigma;
  let sum = 0.0;
  
  const kernel = new Float32Array(dim - !(dim & 1)); // Make it odd number
  const half = parseInt(kernel.length / 2);
  for (let j = 0, i = -half; j < kernel.length; i++, j++) 
  {
    kernel[j] = Math.exp(-(i*i)/(s2)) / sqrtSigmaPi2;
    sum += kernel[j];
  }
  // Normalize the gaussian kernel to prevent image darkening/brightening
  for (let i = 0; i < dim; i++) {
    kernel[i] /= sum;
  }
  return kernel;
};

const gaussianBlurInternal = (pixels, kernel, ch, gray) =>{
  const data = pixels.data;
  const w = pixels.width;
  const h = pixels.height;
  const buff = new Uint8Array(w*h); 
  const mk = Math.floor(kernel.length / 2);
  const kl = kernel.length;
  
  // First step process columns
  for (let j = 0, hw = 0; j < h; j++, hw += w) 
  {
    for (let i = 0; i < w; i++)
    {
      let sum = 0;
      for (let k = 0; k < kl; k++)
      {
        let col = i + (k - mk);
        col = (col < 0) ? 0 : ((col >= w) ? w - 1 : col);
        sum += data[(hw + col)*4 + ch]*kernel[k];
      }
      buff[hw + i] = sum;
    }
  }
  
  // Second step process rows
  for (let j = 0, offset = 0; j < h; j++, offset += w) 
  {
    for (let i = 0; i < w; i++)
    {
      let sum = 0;
      for (let k = 0; k < kl; k++)
      {
        let row = j + (k - mk);
        row = (row < 0) ? 0 : ((row >= h) ? h - 1 : row);
        sum += buff[(row*w + i)]*kernel[k];
      }
      const off = (j*w + i)*4;
      (!gray) ? data[off + ch] = sum : 
                data[off] = data[off + 1] = data[off + 2] = sum;
    }
  }
};

const applyGaussianBlur = (imageData) => {
  const kernel = makeGaussianKernel(gaussianBlurSigma);

  for (let ch = 0; ch < 3; ch++) {
    gaussianBlurInternal(imageData, kernel, ch, false);
  }
};

const isEmailvalid = (value) => {
  let reg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
  if (value) {
    if (reg.test(value) === false) {
      return false;
    } else {
      return true;
    }
  } else {
    return true;
  }
};

export { calcPercentage, cleanSelections, getDefaultPalleteRgb, applyGaussianBlur, isEmailvalid };
